import React from 'react'
import { useInfographicBlockColumnConfig } from '../hooks/useInfographicBlockColumnConfig'
import { useOperationalTable } from '../../../../../organisms/OperationalTable'
import { useCheckPolicy } from '../../../../../../hooks'
import PresentationTable from '../../../../../organisms/PresentationTable'
import { useListInfographicBlocks } from '../../hooks/useListInfographicBlocks'

const InfographicBlocksTable = () => {
  const userIsInternal = useCheckPolicy('internalOnly')

  const onRefetch = async () => {
    await refetch()
  }

  const columnConfig = useInfographicBlockColumnConfig({
    onRefetch,
    userIsInternal
  })

  const {
    pageIndex,
    pageSize,
    sort,
    onPagingChange,
    onSortingChange
  } = useOperationalTable(columnConfig)

  const { data, isLoading, isFetching, refetch } = useListInfographicBlocks({
    limit: pageSize,
    offset: pageIndex * pageSize,
    sort,
    includes: {
      levelTypes: true
    }
  })

  return (
    <>
      <PresentationTable.Wrapper>
        <PresentationTable
          showTotalItemsLabel={false}
          autoSticky
          mode='server'
          columns={columnConfig.columns}
          data={data || []}
          defaultPageSize={100}
          defaultSort={columnConfig.defaultSort}
          itemName='Reports'
          loading={isLoading || isFetching}
          total={data?.length || 0}
          onSortingChange={onSortingChange}
          onPagingChange={onPagingChange}
        />
      </PresentationTable.Wrapper>

    </>
  )
}

export default InfographicBlocksTable
